import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'simplebar';
import 'simplebar/dist/simplebar.css';
import 'react-quill-new/dist/quill.snow.css';
import ResizeObserver from 'resize-observer-polyfill';
import * as Sentry from '@sentry/react';
import { pdfjs } from 'react-pdf';
import { initVersionCheck } from './core/version/versionCheck';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

if (process.env.REACT_APP_SENTRY_ENV !== 'local') {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

window.ResizeObserver = ResizeObserver;

// Keep already-open admin tabs on the latest deployed build. Production only -
// the CRA dev server has its own hot-reload and serves no static
// asset-manifest.json.
if (process.env.NODE_ENV === 'production') {
  initVersionCheck();
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

reportWebVitals();
